import Section9 from '@/components/RoutePage/SectionManager/Section9';
import CalendarFareNewYear from '@/components/RoutePage/SectionManager/Section9/CalendarFareNewYear';
import SearchInput from '@/components/RouteToCityPage/SectionManager/SearchInput';
import React from 'react';

const SectionTetTicket = (props: any) => (
  <div>
    <SearchInput {...props} />
    <Section9 {...props} />
  </div>
);

export default SectionTetTicket;
